import { cva, cx } from 'cva'
import type { ComponentProps, FC } from 'react'

export type TagProps = ComponentProps<'div'> & {
	label: string
	intent?: 'white' | 'blue-tint-10'
}

const intentClasses = cva({
	base: 'w-fit rounded-xs px-sm py-xs',
	variants: {
		intent: {
			white: 'bg-white text-blue-shade-70',
			'blue-tint-10': 'bg-blue-tint-10 text-blue-shade-70',
		},
	},
	defaultVariants: {
		intent: 'white',
	},
})

export const Tag: FC<TagProps> = ({ label, className, intent = 'white', ...props }) => {
	return (
		<div className={cx(intentClasses({ intent }), className)} {...props}>
			<span className="text-h6">{label}</span>
		</div>
	)
}
